import React, { useCallback } from "react";
import styles from "../LeftNavigation.module.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as PresentLogoSVG } from "../../../../assets/editor/present.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../utils/Constant";

const Referral = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = useCallback(async () => {
    navigate(ROUTES.REFER_A_FRIEND);
  }, [navigate]);

  return (
    <div className={styles.actionContainer}>
      <div className={styles.actionItem} onClick={onClick}>
        <div className={styles.actionIcon}>
          <PresentLogoSVG />
        </div>
        <span className={styles.display}>{t("navigation.refer_a_friend")}</span>
      </div>
    </div>
  );
};

export default Referral;
